import {
  forwardRef,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  makeStyles,
} from '@material-ui/core';

import { getSettings } from 'utils/settings';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  cronInput: {
    marginTop: theme.spacing(2),
  },
}));

const Page = forwardRef(({ children, maxWidth, title, ...rest }, ref) => {
  const classes = useStyles();
  const site = getSettings('site', {});

  useEffect(() => {
    const { REACT_APP_STAGE: APP_STAGE } = process.env;
    const stage = APP_STAGE !== 'production'
      ? ` (${APP_STAGE})`
      : '';

    document.title = `${title ? `${title} | ` : ''}${site?.title ?? 'Dynamipay'}${stage}`;

    if (site.favicon) {
      document.querySelector('link[rel="icon"]').href = site.favicon;
    }
  }, [title]);

  return (
    <div className={classes.root} ref={ref} {...rest}>
      <Container
        children={children}
        maxWidth={maxWidth}
      />
    </div>
  );
});

Page.defaultProps = {
  maxWidth: false,
};

Page.displayName = 'Page';

Page.propTypes = {
  children: PropTypes.node,
  favicon: PropTypes.string,
  maxWidth: PropTypes.oneOf([
    'lg',
    'md',
    'sm',
    'xl',
    'xs',
    false,
  ]),
  siteTitle: PropTypes.string,
  title: PropTypes.string,
};

export default Page;
